module.exports = __webpack_public_path__ + "img/6.45d22fbf.png";